$ = jQuery;
$(document).ready(function () {
    $('.report').hide();
    $('#report_lang').on('click', function () {
        $('.report').show();
   });
    
    //IMAGE MAP RESIZE SCRIPT START
    $('.scroll-to-img map').imageMapResize();
    //IMAGE MAP RESIZE SCRIPT END
   
    // Back to top button
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('.back-to-top').fadeIn('slow');
        } else {
            $('.back-to-top').fadeOut('slow');
        }
    });
    $('.back-to-top').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 1500);
        return false;
    });
    setTimeout(function () {
        $('.language-dropdown select option:first-child').text("Select language");
    }, 100);

    //knowldge at a glance search
    $('.knowledge-search').click(function () {
        var keyword = $( "#knowledge-val" ).val();
        var url = window.location.hostname;
        if (url.indexOf('?') > -1){
            url = '/search/node/&keys='+keyword+'&f[]=type:knowledge';
         }else{
            url = '/search/node/?keys='+keyword+'&f[]=type:knowledge';
         }
         window.location = encodeURI(url);
    });
    
    if($("#edit-field-not-applicable-0").is(':checked')){
         $('div.form-item-field-are-you-focal-point').attr('disabled', true);
         $('#edit-field-organisation-target-id').val('');
    }else{
        $('.form-item-field-are-you-focal-point').removeAttr('disabled', true);
    }
    
    $("#trsearch").click(function(){
        $("form#views-exposed-form-thematic-resources-page-1").submit();
    });
    
    $("#trreset").click(function(){
         $("form#views-exposed-form-thematic-resources-page-1").reset();
    });


    //SDG TOOLS PAGE LOAD VIDEOS SCRIPT START
    //$("#report_language").prop("selectedIndex", 1);
    //$('#reportUrl').attr("src", $("#report_language").prop("selectedIndex", 1).val());

    
   
});
